import { useSearchParams } from "react-router-dom";
import { DelaysReportPage } from "./DelaysReportPage";

const DelaysReport = () => {
  const [searchParams] = useSearchParams();
  const assetId = Number(searchParams.get("assetId"));

  return <DelaysReportPage assetId={assetId} key={`${assetId}`} />;
};
export default DelaysReport;
